export default __webpack_public_path__ + "static/media/wealth4.bf80048b.jpg";